import React from 'react';
// logic
// components
import PortalContent from '../components/ui/portal/portalContent';
import createFilterView from '../api/createFilterView';
import { useHistory } from 'react-router-dom';
import filterViewFormSchema from '../components/filterViewsForm/filterViewFormSchema';
import filterViewFormDefaultValues from '../components/filterViewsForm/filterViewFormDefaultValues';
import NewFilterViewToolbar from '../components/filterViewsForm/newFilterViewToolbar';
import FilterViewForm from '../components/filterViewsForm/filterViewForm';

const useNewFilterViewPage = () => {
  const history = useHistory();
  const onSubmit = async ({ filterViewDto }) => {
    await createFilterView({ filterViewDto });
    history.push('/emergencies/filter-views');
  };
  const onCancel = () => {};
  const validationSchema = filterViewFormSchema;
  const initialValues = { ...filterViewFormDefaultValues };
  const isReadOnly = false;
  const isEdit = false;
  return {
    onSubmit,
    onCancel,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
  };
};

const NewFilterViewPage = () => {
  const { onSubmit, onCancel, validationSchema, initialValues, isReadOnly, isEdit } =
    useNewFilterViewPage();

  const filterViewFormData = {
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
  };

  return (
    <>
      <PortalContent>
        <NewFilterViewToolbar />
      </PortalContent>
      <FilterViewForm filterViewFormData={filterViewFormData} />
    </>
  );
};

export default NewFilterViewPage;
